var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"page-user-edit"}},[_c('vx-card',[_c('re-optimization-edit-tab')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }